import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  type = 'website'
}) => {
  const siteName = "SnapED codeCampus";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = "SnapED codeCampus - Your ultimate study companion for GGSIPU B.Tech. Get high-quality notes, PYQs, video lectures, and real-time IPU results.";
  const defaultKeywords = "SnapED, codeCampus, IPU Notes, GGSIPU, B.Tech Notes, Engineering Material, IPU Result, PYQ, CSE, AIML, AIDS, IT";

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:image" content={ogImage || "https://snaped.in/LOGO SnapED.png"} />
      <meta property="og:url" content={ogUrl || window.location.href} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description || defaultDescription} />
      <meta name="twitter:image" content={ogImage || "https://snaped.in/LOGO SnapED.png"} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="theme-color" content="#021526" />
    </Helmet>
  );
};

export default SEO;
